import { useReducer, createContext } from 'react'

export const AmlVerificationContext = createContext()

function setSession(state, payload) {
	return {
		...payload,
	}
}

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_SESSION':
			return setSession(state, action.payload)
		default:
			return state
	}
}

export const AmlVerificationContextProvider = (props) => {
	const [state, dispatch] = useReducer(reducer, {})

	return (
		<AmlVerificationContext.Provider value={[state, dispatch]}>
			{props.children}
		</AmlVerificationContext.Provider>
	)
}
